import { Component, Input, OnInit } from '@angular/core';
import { DownloadItem } from '../../model/download-files.model';
import { Media, MediaComponent } from '@spartacus/storefront';
import { DownloadLinkComponent } from '../download-link/download-link.component';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-download-item',
    templateUrl: './download-item.component.html',
    imports: [MediaComponent, DownloadLinkComponent, TranslatePipe]
})
export class DownloadItemComponent implements OnInit {

  @Input() downloadItem: DownloadItem;
  @Input() defaultThumbnail: Media;
  @Input() styleClasses: string;

  constructor() { }

  ngOnInit(): void { }

}
